import cls from "./GameHistoryList.module.scss";

function formatStatus(status) {
  if (!status) return "Unknown";
  return String(status).replace(/_/g, " ");
}

function formatPenaltyState(state) {
  if (!state) return "not needed";
  return String(state).replace(/_/g, " ");
}

export default function GameHistoryList({
  items = [],
  title = "Turn History",
}) {
  return (
    <section className={cls.card}>
      <div className={cls.glowPink} />
      <div className={cls.glowBlue} />

      <div className={cls.header}>
        <div>
          <p className={cls.eyebrow}>Match Timeline</p>
          <h3 className={cls.title}>{title}</h3>
        </div>

        <div className={cls.badge}>
          {items.length} {items.length === 1 ? "Turn" : "Turns"}
        </div>
      </div>

      {!items.length ? (
        <div className={cls.emptyState}>
          <div className={cls.emptyIcon}>🕹️</div>
          <h4>No history yet</h4>
          <p>No data available yet.</p>
        </div>
      ) : (
        <div className={cls.timeline}>
          {items.map((item, index) => {
            const skipped = item.overrideFlags?.skipped;
            const forceCompleted = item.overrideFlags?.forceCompleted;
            const forcePenaltyResolved =
              item.overrideFlags?.forcePenaltyResolved;

            return (
              <article key={item.turnId || index} className={cls.historyCard}>
                <div className={cls.connector}>
                  <span className={cls.node}>{index + 1}</span>
                  {index !== items.length - 1 ? (
                    <span className={cls.line} />
                  ) : null}
                </div>

                <div className={cls.content}>
                  <div className={cls.topRow}>
                    <div className={cls.roundWrap}>
                      <span className={cls.roundBadge}>
                        Round {item.roundNumber ?? "--"}
                      </span>
                      <h4 className={cls.questionTitle}>
                        {item.questionTitle || "Question"}
                      </h4>
                    </div>

                    <span className={cls.statusBadge}>
                      {formatStatus(item.status)}
                    </span>
                  </div>

                  <div className={cls.playersRow}>
                    <div className={cls.playerBox}>
                      <span className={cls.playerLabel}>Answer Player</span>
                      <strong>{item.answerPlayer?.displayName || "-"}</strong>
                    </div>

                    <div className={cls.vsPill}>VS</div>

                    <div className={cls.playerBox}>
                      <span className={cls.playerLabel}>Guess Player</span>
                      <strong>{item.guessPlayer?.displayName || "-"}</strong>
                    </div>
                  </div>

                  <div className={cls.statsGrid}>
                    <div className={cls.infoCard}>
                      <span className={cls.infoLabel}>Answer</span>
                      <strong>{item.answerSelection || "-"}</strong>
                    </div>

                    <div className={cls.infoCard}>
                      <span className={cls.infoLabel}>Guess</span>
                      <strong>{item.guessSelection || "-"}</strong>
                    </div>

                    <div className={cls.infoCard}>
                      <span className={cls.infoLabel}>Winner</span>
                      <strong>{item.winner?.displayName || "-"}</strong>
                    </div>

                    <div className={cls.infoCard}>
                      <span className={cls.infoLabel}>Loser</span>
                      <strong>{item.loser?.displayName || "-"}</strong>
                    </div>

                    <div className={cls.infoCard}>
                      <span className={cls.infoLabel}>Penalty Mode</span>
                      <strong>{item.penaltyMode || "none"}</strong>
                    </div>

                    <div className={cls.infoCard}>
                      <span className={cls.infoLabel}>Penalty State</span>
                      <strong>{formatPenaltyState(item.penaltyState)}</strong>
                    </div>
                  </div>

                  {(skipped || forceCompleted || forcePenaltyResolved) && (
                    <div className={cls.flags}>
                      {skipped ? (
                        <span className={cls.flag}>Admin skipped</span>
                      ) : null}
                      {forceCompleted ? (
                        <span className={cls.flag}>Force completed</span>
                      ) : null}
                      {forcePenaltyResolved ? (
                        <span className={cls.flag}>Force penalty</span>
                      ) : null}
                    </div>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
}
